export default __webpack_public_path__ + "static/media/office.fa18636f.png";